

import React, { memo } from 'react';
import { FormModal, Text } from '../../../../../../../ui-kit';
import FooterButtons from './FooterButtons';
import '../styles/_topup-modal.scss';

const HELP_LINK = 'https://shootsta.com/#form-block';







const TopupModal = ({
  visible,
  onClose,
  openLiveChatModal
}) => {
  const onClickHelpLink = () => window.open(HELP_LINK, '_blank');

  return (
    <FormModal
      className="topup-modal__form"
      visible={visible}
      onClose={onClose}
      title="Overused your Platform Credits? Fear not Shootsta is here!"
      showCancelBtn={false}
      showExtraButtons
      footerExtraButtons={FooterButtons({ onClickHelpLink, openLiveChatModal })}
      size="MD">

      <div className="topup-modal__content">
        <Text className="topup-modal__description">
          Whatever your budget or situation.
          We have a variety of options to suits your platform needs for you
          to access our professional services and submit projects.
        </Text>
        <Text heading5>Chat to one of our team now to discuss pricing & options.</Text>
      </div>
    </FormModal>);

};

export default memo(TopupModal);